import React from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'
import {FlagIconByLocale} from '~/icons/flag-icons-by-locale'
import {FlagIconsUS} from '../../../icons/flag-icons-us'

export interface MagaUSABadgeProps extends HTMLAttributes<HTMLDivElement> {}

export const MagaLoclaedBrandBadge: FunctionComponent<MagaUSABadgeProps> = ({...props}) => {
  const {language, locale} = useRouteLoaderData('root') as RootLoaderResponse

  const translations = getTranslation(language)

  return (
    <div {...props}>
      <div className="flex w-full shrink-0 flex-row items-center gap-1">
        {locale?.toLowerCase() === 'us' ? (
          <FlagIconsUS className="shrink-0" />
        ) : (
          <FlagIconByLocale locale={locale} className="shrink-0" />
        )}
        <p className="text-sm text-blue-800">
          {translations.Badge.magaBadge(locale?.toLowerCase() === 'ca' ? 'topBrand' : 'born')}
        </p>
      </div>
    </div>
  )
}
